import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import SmsIcon from '@mui/icons-material/Sms';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import _map from 'lodash/map';
import { ReactNode, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import CardCryptoPayment from './CardCryptoPayment';
import HeaderStep, { ButtonData } from './HeaderStep';

interface Steps {
    step: number;
    title: string;
    description: string;
    icon: ReactNode;
}
const steps: Steps[] = [
    {
        step: 1,
        title: 'updates',
        description: 'step-update-description',
        icon: <BrowserUpdatedIcon sx={{ fontSize: '0.9rem' }} color="inherit" />
    },
    {
        step: 2,
        title: 'support',
        description: 'step-support-description',
        icon: <QuestionMarkIcon sx={{ fontSize: '0.9rem' }} color="inherit" />
    },
    {
        step: 3,
        title: 'communication',
        description: 'step-communication-description',
        icon: <SmsIcon sx={{ fontSize: '0.9rem' }} color="inherit" />
    }
];

const StepJoinOnDiscord = () => {
    const theme = useTheme();
    const handleJoin = () => {};
    const buttons = useMemo<ButtonData[]>(
        () => [
            // { id: 1, title: 'join-button', onClick: handleJoin }
        ],
        [handleJoin]
    );

    return (
        <Grid container flexDirection="column" gap={1}>
            <Grid item xs={12}>
                <HeaderStep title="step-join-on-discord-title" buttons={buttons} />
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body1">
                    <FormattedMessage id="step-join-on-discord-description" />
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Grid container sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' } }} gap={2}>
                    {_map(steps, (step) => (
                        <Grid item key={step.step} xs={12} md={6}>
                            <CardCryptoPayment
                                {...step}
                                flexDirection="column"
                                gap={1}
                                sizeIcon={24}
                                childrenIcon={
                                    <Box display="flex" justifyContent="center" alignItems="center" sx={{ color: theme.palette.text.hint }}>
                                        {step.icon}
                                    </Box>
                                }
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default StepJoinOnDiscord;
